import {configureStore} from '@reduxjs/toolkit';

import {getIsAuthenticatedFromStorage} from 'shared/utils/storage';
import {apiMiddlewares} from 'store/api';
import {AUTH_SLICE} from 'store/slices/auth-slice/auth-slice-constants';

import {rootReducer} from './reducers';

const createInitialState = () => ({
    [AUTH_SLICE]: {
        isAuthenticated: getIsAuthenticatedFromStorage() ?? null,
    },
});

export const store = configureStore({
    reducer: rootReducer,
    preloadedState: createInitialState(),
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: {
            ignoreActions: true,
        },
    }).concat(apiMiddlewares),
});
